import { Base } from './base-model';

export class Callout extends Base {
    name: string
    slug: string
    summary: string
    content: string

    static defaults(): Callout {
        const callout = new Callout()
        callout.name = ''
        callout.slug = ''
        callout.summary = ''
        callout.content = ''
        return callout
    }
}
